import { useTranslation } from 'react-i18next'

import { FieldRow, FieldViewValue } from '@/components/layout/field-row'
import { Typography } from '@/components/ui/typography'
import { Building } from '@/reducers/types'

import { OtherFormData } from './other-tab.constants'

interface ApartmentsIdViewProps {
  building: Building
  isAdmin: boolean
  values: OtherFormData
}

export const ApartmentsIdView = ({ building, isAdmin, values }: ApartmentsIdViewProps) => {
  const { t } = useTranslation(['organisation'])

  return (
    <FieldRow label={t('organisation:places.other.apartments.title')}>
      <FieldViewValue>
        {isAdmin ? (
          [values.apartmentsId, building.apartmentsName].filter(Boolean).join(' · ')
        ) : (
          <Typography size="text-small" color="black500">
            {t('organisation:places.other.apartments.adminOnly')}
          </Typography>
        )}
      </FieldViewValue>
    </FieldRow>
  )
}
